module.exports = __webpack_public_path__ + "static/media/sad-mascot.468b636d.svg";